// extracted by mini-css-extract-plugin
module.exports = {"SButton":"WatchlistButton_SButton__rMDjD","SWatchlistIcon":"WatchlistButton_SWatchlistIcon__fu_cO"};